<mat-card class="page-card">
  <div class="mb-3">
    <div class="title">Dias não Trabalhados</div>
    <div class="subtitle">Gerencie feriados e dias não trabalhados.</div>
  </div>

  <!-- FILTROS -->
  <form [formGroup]="filters" class="mb-2">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Ano</mat-label>
          <mat-select formControlName="year">
            <mat-option *ngFor="let y of yearOptions" [value]="y">
              {{ y === 'all' ? 'Todos' : y }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="type">
            <mat-option *ngFor="let t of typeOptions" [value]="t.value">
              {{ t.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-3 btn-add">
        <button mat-flat-button color="primary" (click)="openBlockedDays()">
          <mat-icon>add</mat-icon>
          Adicionar
        </button>
      </div>
    </div>
  </form>

  <!-- TABELA -->
  <div class="table-wrap mt-3">
    <table class="table-simple">
      <thead>
        <tr>
          <th>Data</th>
          <th>Dia da semana</th>
          <th>Tipo</th>
          <th >Ações</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let blockday of filteredBlockDays">

          <td>{{ blockday?.date | date: 'dd/MM/yyyy'}}</td>
          <td>{{ getWeekDay(blockday?.date) }}</td>
          <td>
            <span class="badge-pill badge-holiday">
              {{ blockday?.type | translateBlockDayType }}
            </span>
          </td>
          <td >
            <button
              mat-icon-button
              color="warn"
              aria-label="Remover"
              (click)="confirmDeleteBlockDay(blockday.id)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-card>
